<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.line_list.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_line'], ['read'])"
                        :iportable="false"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickRevision="onRevision"
                        @rowClickCheck="onClickCheck"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>

                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_line'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{$t('general.line_list.create_button')}}
                    </b-btn>

                    <span v-if="this.$store.getters.hasPermission(['project_line'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.line_list.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row">
                    <div class="col-sm-12">
                        <span v-if="this.$store.getters.hasPermission(['project_revisions'], ['read']) && getData.rowData.length > 0">
                            <i class="fa fa-2x fa-list-alt text-info"></i> - {{$t('general.buttons.revision')}} &nbsp; &nbsp;
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="lg" @ok="saveAction" @hidden="saveHidden" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_line'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fluid') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.fluid">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.process_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.process_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.serial_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.serial_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_class') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_class">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_size">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pipe_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.pipe_material">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.tie_in_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_from') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.location_from">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_to') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.location_to">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.operating_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.operating_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.design_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.design_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.testing_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_med') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.testing_med">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_medium') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_medium">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_rt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_rt">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_mt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_mt">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_ut') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_ut">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_others') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_others">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_pt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_pt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.painting_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.painting_thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pwht') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.pwht" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.visual_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.visual_test">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.p_and_id_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.p_and_id_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ped_category">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_module_or_hazard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ped_module_or_hazard">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fluid_phase') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.fluid_phase">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.test_circuit_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.test_circuit_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.cleaning') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.cleaning">
                        </div>
                    </div>


                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_1"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_2"/>
                        </div>
                    </div>
                    
                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="text" disabled v-model="model.revision_number"/>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';

import Multiselect from 'vue-multiselect';
Vue.component(Multiselect);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

export default {
    name: 'line_list',
    components: {
        DataTable,
        ConfirmDialog,
        VeeValidate,
        Multiselect
    },
    data() {
         return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.line_list.title'),
                    active: true
                }
            ],
            tableName: 'line',
            tableNameTranslated: Vue.i18n.translate('general.line_list.title_modal'),
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            isLoading: false,
            searchText: Vue.i18n.translate('general.search.type_to_search_project'),
            selectedProject: {},
            currentProjects: [],
            selectedPressureTest: {},

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            getData: {
                rowData: []
            },

            model: {
                revision_number: null,
                line_number: null,
                project_id: null,
                area: null,
                fluid: null,
                process_code: null,
                serial_no: null,
                line_class: null,
                line_size: null,
                pipe_material: null,
                tie_in_no: null,
                location_from: null,
                location_to: null,
                operating_press: null,
                operating_temp: null,
                design_press: null,
                design_temp: null,
                testing_press: null,
                testing_med: null,
                insulation_or_tracing_type: null,
                insulation_or_tracing_thickness: null,
                insulation_or_tracing_medium: null,
                nde_extent_rt: null,
                nde_extent_mt: null,
                nde_extent_ut: null,
                nde_extent_others: null,
                nde_extent_pt: null,
                painting_code: null,
                painting_thickness: null,
                pwht: null,
                visual_test: null,
                remarks: null,
                p_and_id_no: null,
                ped_category: null,
                ped_module_or_hazard: null,
                fluid_phase: null,
                test_circuit_no: null,
                cleaning: null,
                note_1: null,
                note_2: null,
            },
            columnData: [
                {
                    width: '130px',
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                    showEditButton: true,
                    showRevisionButton: true,
                },
                {
					label: Vue.i18n.translate('table.revision_date'),
					field: 'revision_date',
					numeric: false,
					html: false,
				},
                {
					label: Vue.i18n.translate('table.revision_number'),
					field: 'revision_number',
					numeric: false,
					html: false,
				},
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.fluid'),
                    field: 'fluid',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.process_code'),
                    field: 'process_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_class'),
                    field: 'line_class',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_size'),
                    field: 'line_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pipe_material'),
                    field: 'pipe_material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tie_in_no'),
                    field: 'tie_in_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location_from'),
                    field: 'location_from',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location_to'),
                    field: 'location_to',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.operating_press'),
                    field: 'operating_press',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.operating_temp'),
                    field: 'operating_temp',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.design_press'),
                    field: 'design_press',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.design_temp'),
                    field: 'design_temp',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_press'),
                    field: 'testing_press',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_med'),
                    field: 'testing_med',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_or_tracing_type'),
                    field: 'insulation_or_tracing_type',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_or_tracing_thickness'),
                    field: 'insulation_or_tracing_thickness',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_or_tracing_medium'),
                    field: 'insulation_or_tracing_medium',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.nde_extent_rt'),
                    field: 'nde_extent_rt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.nde_extent_mt'),
                    field: 'nde_extent_mt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.nde_extent_ut'),
                    field: 'nde_extent_ut',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.nde_extent_others'),
                    field: 'nde_extent_others',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.nde_extent_pt'),
                    field: 'nde_extent_pt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.painting_code'),
                    field: 'painting_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.painting_thickness'),
                    field: 'painting_thickness',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pwht'),
                    field: 'pwht',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.visual_test'),
                    field: 'visual_test',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.remarks'),
                    field: 'remarks',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.p_and_id_no'),
                    field: 'p_and_id_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'ped_category',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_module_or_hazard'),
                    field: 'ped_module_or_hazard',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.fluid_phase'),
                    field: 'fluid_phase',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.cleaning'),
                    field: 'cleaning',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.note_1'),
                    field: 'note_1',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.note_2'),
                    field: 'note_2',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        if (this.$store.state.go_back_url == 'pressure_test_planning') {
            this.onLoadTable().then(res => {
                let row = this.getData.rowData.find(r => r.id == this.$store.state.go_back_data_list[0]);

                if(row != null) {
                    this.onEditRow(row);
                }
            });
        } else {
            this.onLoadTable();
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 10000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        async onLoadTable () {
            return new Promise((resolve, reject) => {
                http.route(this.tableName + '?project_id='+this.$route.params.id+'&filters[parent_line_id]=null&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                    if (!response.isError) {
                        this.perPage     = response.pagination.limit;
                        this.rowsCount   = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount   = response.pagination.totalPages;
                        this.getData.rowData = response.data;
                        this.tableLoaded = true;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                    resolve();
                });
            })
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.model.revision_number = null;
            this.model.line_number = null;
            this.model.project_id = null;
            this.model.area = null;
            this.model.fluid = null;
            this.model.process_code = null;
            this.model.serial_no = null;
            this.model.line_class = null;
            this.model.line_size = null;
            this.model.pipe_material = null;
            this.model.tie_in_no = null;
            this.model.location_from = null;
            this.model.location_to = null;
            this.model.operating_press = null;
            this.model.operating_temp = null;
            this.model.design_press = null;
            this.model.design_temp = null;
            this.model.testing_press = null;
            this.model.testing_med = null;
            this.model.insulation_or_tracing_type = null;
            this.model.insulation_or_tracing_thickness = null;
            this.model.insulation_or_tracing_medium = null;
            this.model.nde_extent_rt = null;
            this.model.nde_extent_mt = null;
            this.model.nde_extent_ut = null;
            this.model.nde_extent_others = null;
            this.model.nde_extent_pt = null;
            this.model.painting_code = null;
            this.model.painting_thickness = null;
            this.model.pwht = null;
            this.model.visual_test = null;
            this.model.remarks = null;
            this.model.p_and_id_no = null;
            this.model.ped_category = null;
            this.model.ped_module_or_hazard = null;
            this.model.fluid_phase = null;
            this.model.test_circuit_no = null;
            this.model.cleaning = null;
            this.model.note_1 = null;
            this.model.note_2 = null;
            this.model.rev = null;

            this.$refs.saveModal.show()
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;

            //check if already opened
            this.already_opened_warning = false;
            let data = {
                id: this.row.id,
                object_is_opened_now: 1,
            };
            http.route('line/' + this.row.id).patch(data, true).then(response => {
                if (response.isError == false) {
                    if (typeof response.data != 'undefined') {
                        if (response.data.opened_by != this.$store.state.user.user.id) {
                            this.warnMsg(Vue.i18n.translate('misc.document_is_open'));                      
                        }
                    }
                }
            });
            //end check if already opened

            this.model.revision_number = this.row.revision_number;
            this.model.line_number = this.row.line_number;
            this.model.project_id = this.row.project_id;
            this.model.area = this.row.area;
            this.model.fluid = this.row.fluid;
            this.model.process_code = this.row.process_code;
            this.model.serial_no = this.row.serial_no;
            this.model.line_class = this.row.line_class;
            this.model.line_size = this.row.line_size;
            this.model.pipe_material = this.row.pipe_material;
            this.model.tie_in_no = this.row.tie_in_no;
            this.model.location_from = this.row.location_from;
            this.model.location_to = this.row.location_to;
            this.model.operating_press = this.row.operating_press;
            this.model.operating_temp = this.row.operating_temp;
            this.model.design_press = this.row.design_press;
            this.model.design_temp = this.row.design_temp;
            this.model.testing_press = this.row.testing_press;
            this.model.testing_med = this.row.testing_med;
            this.model.insulation_or_tracing_type = this.row.insulation_or_tracing_type;
            this.model.insulation_or_tracing_thickness = this.row.insulation_or_tracing_thickness;
            this.model.insulation_or_tracing_medium = this.row.insulation_or_tracing_medium;
            this.model.nde_extent_rt = this.row.nde_extent_rt;
            this.model.nde_extent_mt = this.row.nde_extent_mt;
            this.model.nde_extent_ut = this.row.nde_extent_ut;
            this.model.nde_extent_others = this.row.nde_extent_others;
            this.model.nde_extent_pt = this.row.nde_extent_pt;
            this.model.painting_code = this.row.painting_code;
            this.model.painting_thickness = this.row.painting_thickness;
            this.model.pwht = Boolean(this.row.pwht);
            this.model.visual_test = this.row.visual_test;
            this.model.remarks = this.row.remarks;
            this.model.p_and_id_no = this.row.p_and_id_no;
            this.model.ped_category = this.row.ped_category;
            this.model.ped_module_or_hazard = this.row.ped_module_or_hazard;
            this.model.fluid_phase = this.row.fluid_phase;
            this.model.test_circuit_no = this.row.test_circuit_no;
            this.model.cleaning = this.row.cleaning;
            this.model.note_1 = this.row.note_1;
            this.model.note_2 = this.row.note_2;
            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let data = {
                line_number: this.model.line_number,
                project_id: this.$route.params.id,
                area: this.model.area,
                fluid: this.model.fluid,
                process_code: this.model.process_code,
                serial_no: this.model.serial_no,
                line_class: this.model.line_class,
                line_size: this.model.line_size,
                pipe_material: this.model.pipe_material,
                tie_in_no: this.model.tie_in_no,
                location_from: this.model.location_from,
                location_to: this.model.location_to,
                operating_press: this.model.operating_press,
                operating_temp: this.model.operating_temp,
                design_press: this.model.design_press,
                design_temp: this.model.design_temp,
                testing_press: this.model.testing_press,
                testing_med: this.model.testing_med,
                insulation_or_tracing_type: this.model.insulation_or_tracing_type,
                insulation_or_tracing_thickness: this.model.insulation_or_tracing_thickness,
                insulation_or_tracing_medium: this.model.insulation_or_tracing_medium,
                nde_extent_rt: this.model.nde_extent_rt,
                nde_extent_mt: this.model.nde_extent_mt,
                nde_extent_ut: this.model.nde_extent_ut,
                nde_extent_others: this.model.nde_extent_others,
                nde_extent_pt: this.model.nde_extent_pt,
                painting_code: this.model.painting_code,
                painting_thickness: this.model.painting_thickness,
                pwht: this.model.pwht,
                visual_test: this.model.visual_test,
                remarks: this.model.remarks,
                p_and_id_no: this.model.p_and_id_no,
                ped_category: this.model.ped_category,
                ped_module_or_hazard: this.model.ped_module_or_hazard,
                fluid_phase: this.model.fluid_phase,
                test_circuit_no: this.model.test_circuit_no,
                cleaning: this.model.cleaning,
                note_1: this.model.note_1,
                note_2: this.model.note_2,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.row) {
                data['id'] = this.row.id;
                //check if already opened
                data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route('line/' + this.row.id).patch(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable();

                        this.$refs.saveModal.hide();
                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                               this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                http.route('line').post(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.onLoadTable();

                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onRevision(row) {
            this.$router.push({name: 'line_list_revisioncontrol', params: {id:this.$route.params.id, id2: row.id}});
        },
        saveHidden(e) {
            //check if already opened
            this.already_opened_warning = false;
            if (this.row != null) {
                let data = {
                    id: this.row.id,
                    object_is_opened_now: 0,
                };
                http.route(this.tableName + '/' + this.row.id).patch(data, true);
            }
            //end check if already opened

            if(this.$store.state.go_back_url == 'pressure_test_planning') {
                this.$store.state.go_back_url = 'line_list';
                this.$router.push({name: 'pressure_test_planning', params: {id:this.$route.params.id}});
            }
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        onExportButton() {
            http.route(this.tableName + '?project_id=' + this.$route.params.id).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'lines.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });
            http.route(this.tableName+'/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/line_list/line_list.vue